import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import UserContext from "../context/UserContext";
import { FaCog, FaBars, FaTimes } from "react-icons/fa"; // Install react-icons with `npm install react-icons`

const Navigation = ({ className }) => {
  const navigate = useNavigate();
  const { user, loading } = useContext(UserContext);
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  const closeMenu = () => setIsOpen(false);

  if (loading) {
    return null; // Or a loading spinner
  }

  return (
    <nav className={`bg-gradient-to-r from-adults-black via-teens-gray to-adults-black p-4 shadow-2xl relative z-50 backdrop-blur-sm border-b border-silver/20 ${className}`}>
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center text-2xl font-bold text-white hover:text-silver transition-colors duration-300">
          <img src="/logo512.png" alt="Rocket Trail Logo" className="w-8 h-8 sm:w-10 sm:h-10 mr-2 animate-pulse" />
          Rocket Trail
        </Link>
        {/* Right Side Navigation */}
        <div className="flex items-center space-x-1">
          {/* Desktop Navigation */}
          <div className="hidden xl:flex space-x-1 items-center">
            {user ? (
              <>
                <Link to="/" className="bg-kids-blue/20 text-white px-3 py-2 h-10 rounded-lg hover:bg-kids-blue/40 hover:shadow-lg hover:shadow-kids-blue/50 transition-all duration-300 border border-kids-blue/30 whitespace-nowrap flex items-center">Home</Link>
                <Link to="/launch-schedule" className="bg-kids-blue/20 text-white px-3 py-2 h-10 rounded-lg hover:bg-kids-blue/40 hover:shadow-lg hover:shadow-kids-blue/50 transition-all duration-300 border border-kids-blue/30 whitespace-nowrap flex items-center">Launch Schedule</Link>
                <Link to="/mars" className="bg-kids-blue/20 text-white px-3 py-2 h-10 rounded-lg hover:bg-kids-blue/40 hover:shadow-lg hover:shadow-kids-blue/50 transition-all duration-300 border border-kids-blue/30 whitespace-nowrap flex items-center">Mars Hub</Link>
                <Link to="/globe" className="bg-kids-blue/20 text-white px-3 py-2 h-10 rounded-lg hover:bg-kids-blue/40 hover:shadow-lg hover:shadow-kids-blue/50 transition-all duration-300 border border-kids-blue/30 whitespace-nowrap flex items-center">Satellite Tracker</Link>
                <Link to="/iss-tracker" className="bg-kids-blue/20 text-white px-3 py-2 h-10 rounded-lg hover:bg-kids-blue/40 hover:shadow-lg hover:shadow-kids-blue/50 transition-all duration-300 border border-kids-blue/30 whitespace-nowrap flex items-center">ISS Tracker</Link>
                <Link to="/learn" className="bg-kids-blue/20 text-white px-3 py-2 h-10 rounded-lg hover:bg-kids-blue/40 hover:shadow-lg hover:shadow-kids-blue/50 transition-all duration-300 border border-kids-blue/30 whitespace-nowrap flex items-center">Learn</Link>
                <Link to="/games" className="bg-kids-blue/20 text-white px-3 py-2 h-10 rounded-lg hover:bg-kids-blue/40 hover:shadow-lg hover:shadow-kids-blue/50 transition-all duration-300 border border-kids-blue/30 whitespace-nowrap flex items-center">Games</Link>
                <Link to="/forum" className="bg-kids-blue/20 text-white px-3 py-2 h-10 rounded-lg hover:bg-kids-blue/40 hover:shadow-lg hover:shadow-kids-blue/50 transition-all duration-300 border border-kids-blue/30 whitespace-nowrap flex items-center">Forum</Link>
                <Link to="/livestreams" className="bg-kids-blue/20 text-white px-3 py-2 h-10 rounded-lg hover:bg-kids-blue/40 hover:shadow-lg hover:shadow-kids-blue/50 transition-all duration-300 border border-kids-blue/30 whitespace-nowrap flex items-center">Livestreams</Link>
                {user && user.email === "adamkfrancis1989@gmail.com" && (
                  <Link to="/admin" className="bg-kids-blue/20 text-white px-3 py-2 h-10 rounded-lg hover:bg-kids-blue/40 hover:shadow-lg hover:shadow-kids-blue/50 transition-all duration-300 border border-kids-blue/30 whitespace-nowrap flex items-center">Admin</Link>
                )}
              </>
            ) : (
              <>
                <Link to="/login" className="bg-kids-blue/20 text-white px-3 py-2 h-10 rounded-lg hover:bg-kids-blue/40 hover:shadow-lg hover:shadow-kids-blue/50 transition-all duration-300 border border-kids-blue/30 whitespace-nowrap flex items-center">Login</Link>
                <Link to="/signup" className="bg-gradient-to-r from-green-500 to-green-700 text-white px-3 py-2 h-10 rounded-lg hover:from-green-600 hover:to-green-800 hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 border border-green-400/30 whitespace-nowrap flex items-center">Sign Up</Link>
              </>
            )}
          </div>

          {/* Mobile Hamburger Menu */}
          <div className="xl:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white hover:text-silver transition-colors duration-300"
            >
              {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>

          {/* Always Visible Icons */}
          {user && (
            <>
              <Link to="/profile" className="w-10 h-10 bg-kids-blue/20 text-white rounded-lg hover:bg-kids-blue/40 hover:shadow-lg hover:shadow-kids-blue/50 transition-all duration-300 border border-kids-blue/30 flex items-center justify-center">
                <FaCog size={16} />
              </Link>
              <button
                onClick={handleLogout}
                className="w-10 h-10 p-0 bg-gradient-to-r from-red-500 to-red-700 text-white rounded-lg hover:from-red-600 hover:to-red-800 hover:shadow-lg hover:shadow-red-500/50 transition-all duration-300 border border-red-400/30 flex items-center justify-center"
              >
                <span className="text-xl font-bold">×</span>
              </button>
            </>
          )}
        </div>

        {/* Mobile Dropdown Menu */}
        {isOpen && (
          <div className="xl:hidden absolute top-full right-0 w-64 bg-gradient-to-r from-adults-black via-teens-gray to-adults-black shadow-2xl border border-silver/20 rounded-lg z-40">
            <div className="p-4 space-y-2">
              {user ? (
                <>
                  <Link to="/" onClick={closeMenu} className="block bg-kids-blue/20 text-white px-3 py-2 rounded-lg hover:bg-kids-blue/40 transition-all duration-300 border border-kids-blue/30">Home</Link>
                  <Link to="/launch-schedule" onClick={closeMenu} className="block bg-kids-blue/20 text-white px-3 py-2 rounded-lg hover:bg-kids-blue/40 transition-all duration-300 border border-kids-blue/30">Launch Schedule</Link>
                  <Link to="/mars" onClick={closeMenu} className="block bg-kids-blue/20 text-white px-3 py-2 rounded-lg hover:bg-kids-blue/40 transition-all duration-300 border border-kids-blue/30">Mars Hub</Link>
                  <Link to="/globe" onClick={closeMenu} className="block bg-kids-blue/20 text-white px-3 py-2 rounded-lg hover:bg-kids-blue/40 transition-all duration-300 border border-kids-blue/30">Satellite Tracker</Link>
                  <Link to="/iss-tracker" onClick={closeMenu} className="block bg-kids-blue/20 text-white px-3 py-2 rounded-lg hover:bg-kids-blue/40 transition-all duration-300 border border-kids-blue/30">ISS Tracker</Link>
                  <Link to="/learn" onClick={closeMenu} className="block bg-kids-blue/20 text-white px-3 py-2 rounded-lg hover:bg-kids-blue/40 transition-all duration-300 border border-kids-blue/30">Learn</Link>
                  <Link to="/games" onClick={closeMenu} className="block bg-kids-blue/20 text-white px-3 py-2 rounded-lg hover:bg-kids-blue/40 transition-all duration-300 border border-kids-blue/30">Games</Link>
                  <Link to="/forum" onClick={closeMenu} className="block bg-kids-blue/20 text-white px-3 py-2 rounded-lg hover:bg-kids-blue/40 transition-all duration-300 border border-kids-blue/30">Forum</Link>
                  <Link to="/livestreams" onClick={closeMenu} className="block bg-kids-blue/20 text-white px-3 py-2 rounded-lg hover:bg-kids-blue/40 transition-all duration-300 border border-kids-blue/30">Livestreams</Link>
                  {user && user.email === "adamkfrancis1989@gmail.com" && (
                    <Link to="/admin" onClick={closeMenu} className="block bg-kids-blue/20 text-white px-3 py-2 rounded-lg hover:bg-kids-blue/40 transition-all duration-300 border border-kids-blue/30">Admin</Link>
                  )}
                </>
              ) : (
                <>
                  <Link to="/login" onClick={closeMenu} className="block bg-kids-blue/20 text-white px-3 py-2 rounded-lg hover:bg-kids-blue/40 transition-all duration-300 border border-kids-blue/30">Login</Link>
                  <Link to="/signup" onClick={closeMenu} className="block bg-gradient-to-r from-green-500 to-green-700 text-white px-3 py-2 rounded-lg hover:from-green-600 hover:to-green-800 transition-all duration-300 border border-green-400/30">Sign Up</Link>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
